import React from 'react'
import NotesStore from '../Store/NotesStore'
import NoteElement from './NoteElement'
import { Subscribe } from 'unstated'
import Loading from '../../../Components/Loading/Loading'
import DownloadNotes from './DownloadNotes'

const DashboardNotes = ({ blockEdit }) => {
  return (
    <Subscribe to={[NotesStore]}>
      {({ state, updateNote }) =>
        state.loading ? (
          <Loading />
        ) : (
          <div className='notes'>
            <DownloadNotes />
            {state.notes.map((note, index) => (
              <NoteElement
                key={'note' + index}
                noteTitle={note.noteTitle}
                url={note.updateUrl}
                value={note.note}
                onChange={(value) => updateNote(index, value)}
                paramName={state.paramName}
                blockEdit={blockEdit}
              />
            ))}
          </div>
        )
      }
    </Subscribe>
  )
}

export default DashboardNotes
